import ElementConfig from './ElementConfig';
var FormItem = /** @class */ (function () {
    function FormItem(formItem) {
        if (formItem === undefined) {
            formItem = {
                'id': 0,
                'groupId': 0,
                'elementType': '',
                'value': '',
                'label': '',
                'elementConfig': new ElementConfig({
                    'className': '',
                    'placeholder': '',
                    'type': '',
                    'futureDateValidation': false
                }),
                'addon': {},
                'validation': {},
                'valid': false,
                'touched': false,
                'errorMsg': '',
                'maxLength': null,
                'formatter': '',
                'hidden': false,
                'viewDate': new Date(),
                'wrapperClass': '',
                'labelExtraClass': '',
                'itemType': ''
            };
        }
        this.id = formItem.id;
        this.groupId = formItem.groupId;
        this.elementType = formItem.elementType;
        this.value = formItem.value;
        this.label = formItem.label;
        this.elementConfig = formItem.elementConfig;
        this.addon = formItem.addon;
        this.validation = formItem.validation;
        this.valid = formItem.valid;
        this.touched = formItem.touched;
        this.errorMsg = formItem.errorMsg;
        this.maxLength = formItem.maxLength;
        this.formatter = formItem.formatter;
        this.futureDateValidation = formItem.futureDateValidation;
        this.hidden = formItem.hidden;
        this.viewDate = formItem.viewDate;
        this.wrapperClass = formItem.wrapperClass;
        this.labelExtraClass = formItem.labelExtraClass;
        this.itemType = formItem.itemType;
    }
    return FormItem;
}());
export default FormItem;



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/formItem/FormItem.ts
// module id = 13
// module chunks = 0